/* global axios */
import ApiClient from './ApiClient';

class MessageTemplatesAPI extends ApiClient {
  constructor() {
    super('templates', { accountScoped: true });
  }

  // Generator preview: one master body -> per-channel variants (stateless).
  preview({
    body,
    image_url,
    overrides,
    buttons,
    ical,
    channel_variants,
    channels,
    vars,
  }) {
    return axios.post(`${this.url}/preview`, {
      body,
      image_url,
      overrides,
      buttons,
      ical,
      channel_variants,
      channels,
      vars,
    });
  }

  // Real test send of a saved template's channel variant to a phone/chat id.
  testSend(id, { channel, inbox_id, to, vars }) {
    return axios.post(`${this.url}/${id}/test_send`, {
      channel,
      inbox_id,
      to,
      vars,
    });
  }

  // Pull approved WABA templates from the connected Wazzup24 source and upsert them.
  syncWazzup() {
    return axios.post(`${this.url}/sync_wazzup`);
  }
}

export default new MessageTemplatesAPI();
